/**
 * Converts a client created date string to a Date object for use in date range forms
 * @param clientCreatedDate - The client created date string
 * @returns Date object with UTC hours set to 0, or undefined if no date provided
 */
export const getClientCreatedDateForDateRange = (clientCreatedDate?: string): Date | undefined => {
  if (!clientCreatedDate) return undefined;

  const d = new Date(clientCreatedDate);
  d.setUTCHours(0, 0, 0, 0);
  return d;
};
